<template>
  <div id="app">
    <div v-if="showModalAddImage">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Chọn ảnh</h5>
                  <button
                    type="button"
                    @click="closeAddImage()"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center" style="max-height: 500px; overflow: scroll">
                  <div class="form-group row img-list mr-0 ml-0">
                    <ul>
                      <li v-for="(item, index) in imageData" :key="index">
                        <a href="#popup-slider" data-toggle="modal">
                          <img :src="item" alt="" />
                          <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                        </a>
                      </li>
                      <li>
                        <div class="add-img">
                          <span class="bx bx-plus text-center"></span>
                          <input @input="onSelectFile" ref="fileInput" type="file" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="modal-footer">
                  <button type="button" @click="closeAddImage()" class="btn btn-light">Đóng</button>
                  <button @click="submitAdd()" type="button" class="btn btn-primary">
                    Thêm ảnh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <loading :active.sync="showLoading" :is-full-page="true"> </loading>
  </div>
</template>

<script>
  import { CommonService } from '@/services/common.service'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    props: ['showModalAddImage', 'dataUploadImage'],

    data() {
      return {
        dataUser: JSON.parse(localStorage.getItem('userData')),
        formData: new FormData(),
        arrayFormData: [],
        arrayImgAddSuccess: [],
        imageData: [],

        messErr: '',
        showLoading: false,
        dataImageToAdd: [],
      }
    },

    components: {
      Loading,
    },

    updated() {
      this.imageData = this.dataUploadImage
      if (this.dataUploadImage && this.dataUploadImage.length)
        this.arrayImgAddSuccess = this.dataUploadImage
    },

    methods: {
      async onSelectFile() {
        if (this.imageData && this.imageData.length === 20) {
          this.$emit('error', 'Chỉ tải lên tối đa 20 ảnh')
          return
        }

        const input = this.$refs.fileInput
        const files = input.files
        const fomatUpload = ['image/jpeg', 'image/png']
        const checkFomat = fomatUpload.includes(input.files[0].type)
        if (!checkFomat) {
          alert('Định dạng ảnh không đúng')
          return
        }

        var FileSize = input.files[0].size / 1024 / 1024 // in MB

        // if (FileSize > 5) {
        //   alert('Size ảnh quá lớn')
        //   return
        // }

        this.formData = new FormData()

        if (FileSize > 2) {
          this.resizeImage({ file: files[0], maxSize: 450 })
        } else {
          this.formData.append('files', files[0])
          this.formData.append('folderName', 'Images')
          this.arrayFormData.push(this.formData)
        }

        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },

      async closeAddImage() {
        this.imageData = []
        this.arrayImgAddSuccess = []
        this.dataImageToAdd = []
        this.arrayFormData = []
        this.$emit('close')
      },

      async submitAdd() {
        try {
          this.$emit('close')
          this.showLoading = true
          await this.uploadImg()
          if (this.arrayFormData.length !== 0)
            await this.$emit('submitAddImage', this.dataImageToAdd)
          this.showLoading = false
          this.closeAddImage()
        } catch (error) {
          console.log(error)
        }
      },

      async uploadImg() {
        try {
          // this.arrayImgAddSuccess = []
          for (let index = 0; index < this.arrayFormData.length; index++) {
            const element = this.arrayFormData[index]
            await CommonService.uploadImg(element)
              .then(res => {
                if (res.code === 1000) {
                  this.arrayImgAddSuccess.push(res.data[0])
                }
              })
              .catch(error => {
                console.log(error)
                alert('Đã có lỗi xảy khi upload ảnh')
              })
          }
          this.arrayImgAddSuccess.map(e => {
            if (e.includes('https')) this.dataImageToAdd.push(e)
          })
        } catch (error) {
          console.log('add img reader', error)
        }
      },

      removeImg(index) {
        this.arrayImgAddSuccess.splice(index, 1)
      },

      dataURItoBlob(dataURI) {
        const bytes =
          dataURI.split(',')[0].indexOf('base64') >= 0
            ? atob(dataURI.split(',')[1])
            : unescape(dataURI.split(',')[1])
        const mime = dataURI.split(',')[0].split(':')[1].split(';')[0]
        const max = bytes.length
        const ia = new Uint8Array(max)
        for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i)
        return new Blob([ia], { type: mime })
      },

      resizeImage({ file, maxSize }) {
        const reader = new FileReader()
        const image = new Image()
        const canvas = document.createElement('canvas')

        const resize = () => {
          let { width, height } = image

          if (width > height) {
            if (width > maxSize) {
              height *= maxSize / width
              width = maxSize
            }
          } else if (height > maxSize) {
            width *= maxSize / height
            height = maxSize
          }

          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(image, 0, 0, width, height)

          const dataUrl = canvas.toDataURL('image/jpeg')

          const resizedImg = this.dataURItoBlob(dataUrl)

          this.formData.append('files', resizedImg)
          this.formData.append('folderName', 'Images')
          this.arrayFormData.push(this.formData)

          // return this.dataURItoBlob(dataUrl)
        }

        reader.onload = readerEvent => {
          image.onload = () => resize()
          image.src = readerEvent.target.result
        }

        reader.readAsDataURL(file)
      },
    },
  }
</script>

<style scoped>
  .modal-dialog {
    margin-top: 0;
  }
</style>
